<template>
    <div>
        <modal class="new-modal-default lead-stage-profile-popup" :name="modal_name" transition="nice-modal-fade" :delay="100" :width="500"
            :height="325" :pivot-y="0.5" :adaptive="true" :scrollable="false"  style="pointer-events:inherit !important" v-bind:click-to-close="false">
            <div class="v-modal-content" style="background-color: #ffffff !important;">
                <div class="v-modal-header">
                    <div></div>
                    <div>
                        <span class="v-modal-dialog-title v-modal-title">Lead Profile  {{profile_details.user_name}}</span>
                    </div>
                    <div>
                        <span class="icon icon-close mr-2 text-white pointer close-left" @click="hideLeadProfileModal()"></span>
                    </div>
                </div>
                <div class="d-flex align-items-center justify-content-center" v-if="ajaxCallInProgress" style="height: 250px;">
                    <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
                </div>
                <div v-else class="v-modal-body pb-0">
                 <div class="col-lg-12 col-md-12 col-sm-12 pl-0 mt-3 col-md-offset-2 v-modal-width">
                    <!-- <div class="v-modal-layout px-4" style="position: relative;" >
                        <div class="d-flex justify-content-center">
                            <div v-for="(stage, stage_index) in profile_details.stage_details" :key="stage_index">
                                <div v-if="stage.stage_status == 'pending'" class="mt-4 step-circle-static" :class="{'step-circle-static6':no_of_stages == '6', 'step-circle-static5':no_of_stages == '5', 'step-circle-static4':no_of_stages == '4', 'step-circle-static3':no_of_stages == '3', 'step-circle-static2':no_of_stages == '2'}">
                                    <span v-if="no_of_stages == 6" class="static fs-14 stage-name stage-6">{{ stage.stage_name }}</span>
                                    <span v-if="no_of_stages == 5" class="static fs-14 stage-name stage-5">{{ stage.stage_name }}</span>
                                    <span v-if="no_of_stages == 4" class="static fs-14 stage-name stage-4">{{ stage.stage_name }}</span>
                                    <span v-if="no_of_stages == 3" class="static fs-14 stage-name stage-3">{{ stage.stage_name }}</span>
                                    <span v-if="no_of_stages == 2" class="static fs-14 stage-name stage-2">{{ stage.stage_name }}</span>
                                    <span v-if="no_of_stages == 1" class="static fs-14 stage-name stage-1">{{ stage.stage_name }}</span>
                                </div>
                                <div v-if="stage.stage_status == 'active'" class="mt-4 step-circle-active" :class="{'step-circle-active6':no_of_stages == '6', 'step-circle-active5':no_of_stages == '5', 'step-circle-active4':no_of_stages == '4', 'step-circle-active3':no_of_stages == '3', 'step-circle-active2':no_of_stages == '2'}">
                                    <span v-if="no_of_stages == 6" class="active fs-14 stage-name stage-6">{{ stage.stage_name }}</span>
                                    <span v-if="no_of_stages == 5" class="active fs-14 stage-name stage-5">{{ stage.stage_name }}</span>
                                    <span v-if="no_of_stages == 4" class="active fs-14 stage-name stage-4">{{ stage.stage_name }}</span>
                                    <span v-if="no_of_stages == 3" class="active fs-14 stage-name stage-3">{{ stage.stage_name }}</span>
                                    <span v-if="no_of_stages == 2" class="active fs-14 stage-name stage-2">{{ stage.stage_name }}</span>
                                    <span v-if="no_of_stages == 1" class="active fs-14 stage-name stage-1">{{ stage.stage_name }}</span>
                                </div>
                                <div v-if="stage.stage_status == 'hold'" class="mt-4 step-circle-block" :class="{'step-circle-block6':no_of_stages == '6', 'step-circle-block5':no_of_stages == '5', 'step-circle-block4':no_of_stages == '4', 'step-circle-block3':no_of_stages == '3', 'step-circle-block2':no_of_stages == '2'}">
                                    <span v-if="no_of_stages == 6" class="block fs-14 stage-name stage-6">{{ stage.stage_name }}</span>
                                    <span v-if="no_of_stages == 5" class="block fs-14 stage-name stage-5">{{ stage.stage_name }}</span>
                                    <span v-if="no_of_stages == 4" class="block fs-14 stage-name stage-4">{{ stage.stage_name }}</span>
                                    <span v-if="no_of_stages == 3" class="block fs-14 stage-name stage-3">{{ stage.stage_name }}</span>
                                    <span v-if="no_of_stages == 2" class="block fs-14 stage-name stage-2">{{ stage.stage_name }}</span>
                                    <span v-if="no_of_stages == 1" class="block fs-14 stage-name stage-1">{{ stage.stage_name }}</span>
                                </div>
                                <div v-if="stage.stage_status == 'complete'" class="mt-4 step-circle-complete" :class="{'step-circle-complete6':no_of_stages == '6', 'step-circle-complete5':no_of_stages == '5', 'step-circle-complete4':no_of_stages == '4', 'step-circle-complete3':no_of_stages == '3', 'step-circle-complete2':no_of_stages == '2'}">
                                    <span v-if="no_of_stages == 6" class="complete fs-14 stage-name stage-6">{{ stage.stage_name }}</span>
                                    <span v-if="no_of_stages == 5" class="complete fs-14 stage-name stage-5">{{ stage.stage_name }}</span>
                                    <span v-if="no_of_stages == 4" class="complete fs-14 stage-name stage-4">{{ stage.stage_name }}</span>
                                    <span v-if="no_of_stages == 3" class="complete fs-14 stage-name stage-3">{{ stage.stage_name }}</span>
                                    <span v-if="no_of_stages == 2" class="complete fs-14 stage-name stage-2">{{ stage.stage_name }}</span>
                                    <span v-if="no_of_stages == 1" class="complete fs-14 stage-name stage-1">{{ stage.stage_name }}</span>
                                </div>
                                <div v-if="stage.stage_status == 'skipped'" class="mt-4 step-circle-skip" :class="{'step-circle-skip6':no_of_stages == '6', 'step-circle-skip5':no_of_stages == '5', 'step-circle-skip4':no_of_stages == '4', 'step-circle-skip3':no_of_stages == '3', 'step-circle-skip2':no_of_stages == '2'}">
                                    <span v-if="no_of_stages == 6" class="skip fs-14 stage-name stage-6">{{ stage.stage_name }}</span>
                                    <span v-if="no_of_stages == 5" class="skip fs-14 stage-name stage-5">{{ stage.stage_name }}</span>
                                    <span v-if="no_of_stages == 4" class="skip fs-14 stage-name stage-4">{{ stage.stage_name }}</span>
                                    <span v-if="no_of_stages == 3" class="skip fs-14 stage-name stage-3">{{ stage.stage_name }}</span>
                                    <span v-if="no_of_stages == 2" class="skip fs-14 stage-name stage-2">{{ stage.stage_name }}</span>
                                    <span v-if="no_of_stages == 1" class="skip fs-14 stage-name stage-1">{{ stage.stage_name }}</span>
                                </div>
                            </div>
                        </div>
                        <div v-if="no_of_stages == 2" class="mt-4 stage-two-step-bar-line"></div>
                        <div v-if="no_of_stages == 3" class="mt-4 stage-three-step-bar-line"></div>
                        <div v-if="no_of_stages == 4" class="mt-4 stage-four-step-bar-line"></div>
                        <div v-if="no_of_stages == 5" class="mt-4 stage-five-step-bar-line"></div>
                        <div v-if="no_of_stages == 6" class="mt-4 stage-six-step-bar-line"></div>
                    </div> -->
                    <div class="v-modal-layout px-4" >
                        <div class="pearls row main-scroll">
                            <div class="d-flex justify-content-center">
                                <div v-for="(stage, stage_index) in profile_details.stage_details" :key="stage_index">
                                    <div v-if="stage.stage_status == 'pending'" class="pending" :class="{'col-2':no_of_stages == 6, 'five-stage':no_of_stages == 5, 'col-3':no_of_stages == 4, 'col-4':no_of_stages == 3, 'col-6':no_of_stages == 2, 'col-12':no_of_stages == 1, 'pending-b':stage_index == 0, 'pending-a':stage_index == no_of_stages-1}">
                                        <div class="pearl-icon"></div>
                                        <span class="pending-title px-2">{{ stage.stage_name }}</span>
                                    </div>
                                    <div v-if="stage.stage_status == 'active'" class="active" :class="{'col-2':no_of_stages == 6, 'five-stage':no_of_stages == 5, 'col-3':no_of_stages == 4, 'col-4':no_of_stages == 3, 'col-6':no_of_stages == 2, 'col-12':no_of_stages == 1, 'active-b':stage_index == 0, 'active-a':stage_index == no_of_stages-1}">
                                        <div class="pearl-icon"></div>
                                        <span class="active-title px-2">{{ stage.stage_name }}</span>
                                    </div>
                                    <div v-if="stage.stage_status == 'hold'" class="hold" :class="{'col-2':no_of_stages == 6, 'five-stage':no_of_stages == 5, 'col-3':no_of_stages == 4, 'col-4':no_of_stages == 3, 'col-6':no_of_stages == 2, 'col-12':no_of_stages == 1, 'hold-b':stage_index == 0, 'hold-a':stage_index == no_of_stages-1}">
                                        <div class="pearl-icon"></div>
                                        <span class="hold-title px-2">{{ stage.stage_name }}</span>
                                    </div>
                                    <div v-if="stage.stage_status == 'complete'" class="complete" :class="{'col-2':no_of_stages == 6, 'five-stage':no_of_stages == 5, 'col-3':no_of_stages == 4, 'col-4':no_of_stages == 3, 'col-6':no_of_stages == 2, 'col-12':no_of_stages == 1, 'complete-b':stage_index == 0, 'complete-a':stage_index == no_of_stages-1}">
                                        <div class="pearl-icon"></div>
                                        <span class="complete-title px-2">{{ stage.stage_name }}</span>
                                    </div>
                                    <div v-if="stage.stage_status == 'skip'" class="skip" :class="{'col-2':no_of_stages == 6, 'five-stage':no_of_stages == 5, 'col-3':no_of_stages == 4, 'col-4':no_of_stages == 3, 'col-6':no_of_stages == 2, 'col-12':no_of_stages == 1, 'skip-b':stage_index == 0, 'skip-a':stage_index == no_of_stages-1}">
                                        <div class="pearl-icon"></div>
                                        <span class="skip-title px-2">{{ stage.stage_name }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <hr class="mt-15 mb-8 line-color"> -->
                    <div class="mt-4 pl-4 pt-20">
                        <div class="row">
                            <div class="col-lg-4 col-md-4 col-sm-4 v-modal-width">
                                <p class="text-capitalize fw-500 fs-12"><span class="text-secondary">Current Stage :</span> {{current_stage.replace(/_/g,' ')}}</p>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-4 v-modal-width">
                                <p class="text-capitalize fw-500 fs-12"><span class="text-secondary">Sales Lead :</span> {{profile_details.user_name || "-"}}</p>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-4 v-modal-width">
                                <p class="fw-500 fs-12"><span class="text-secondary">Last Contacted :</span> {{profile_details.last_contacted_date}}</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-4 col-md-4 col-sm-4 v-modal-width">
                                <p class="fw-500 fs-12"><span class="text-secondary">Product Associated :</span> {{product.product_name || "-"}}</p>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-4 v-modal-width">
                                <p class="fw-500 fs-12"><span class="text-secondary">Amount Inquired({{currency}}):</span> {{product.amount_inquired || "-"}}</p>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-4 v-modal-width">
                                <p class="fw-500 fs-12"><span class="text-secondary">Price Quoted ({{currency}}):</span> {{product.price_quoted || "-"}}</p>
                            </div>
                        </div>
                    </div>
                 </div>
                </div>
                <div v-if="!ajaxCallInProgress" class="v-modal-dialog-actions d-flex justify-content-between align-items-center pt-0 mt-0">
                    <div v-if="course_of_action.activity_name" class="d-flex">
                        <p class="text-secondary pl-4 fs-12 fw-500">Recent Activity : <span class="text-black text-capitalize fs-12 fw-500"> {{course_of_action.action_type.replace(/_/g, ' ')}} {{course_of_action.activity_name.replace(/_/g, ' ')}}</span></p>
                    </div>
                    <div v-else class="d-flex fs-12 fw-500">
                        <p class="text-secondary pl-4">Recent Activity : <span class="text-black text-capitalize fs-12 fw-500"> - </span></p>
                    </div>
                    <button class="btn btn-des-small ml-2 mr-2 btn-new-blue" @click="viewLead(selected_lead_id)">More Info</button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import leads from "../mixins/leads";
import { HalfCircleSpinner } from "epic-spinners";
export default {
    props: ["modal_name","selected_lead_id"],
    mixins: [leads],
    components: {
        HalfCircleSpinner
    },
    data(){
        return {
            ajaxCallInProgress: false,
            lead_type: "",
            profile_details: [],
            current_stage: "",
            no_of_stages: 0,
            currency: "",
            product: [],
            course_of_action: [],
        }
    },
    methods: {
        hideLeadProfileModal() {
            this.$emit("hideLeadProfileModal");
        },
        viewLead(id){
            this.$emit("viewLead", id);
        },
        async loadLeadProfileDetails(){
            this.ajaxCallInProgress = true;
            let response
            if(this.lead_type == "Manual"){
                response = await this.getActiveLeadProfileData(this.selected_lead_id)
            } else if(this.lead_type == "Archive"){
                response = await this.getArchiveLeadProfileData(this.selected_lead_id)
            } else if(this.lead_type == "Converted"){
                response = await this.getConvertedLeadProfileData(this.selected_lead_id)
            }
            this.profile_details = response.response;
            this.product = this.profile_details.product
            this.course_of_action = this.profile_details.course_of_action
            this.current_stage = response.current_stage;
            this.no_of_stages = response.count;
            this.ajaxCallInProgress = false;
        }
    },
    mounted(){
        this.ajaxCallInProgress = true;
        this.lead_type = localStorage.getItem("leads_type")
        this.currency = this.loggedInUser.currency.symbol;
        this.loadLeadProfileDetails();
    },
    computed: {
        loggedInUser() {
            return this.$store.state.loggedInUser;
        },
    },
}
</script>
<style scoped>
    .btn-new-blue {
        border: 2px solid #005dae;
        color:#fff;
        line-height: 30px;
        border-radius: 5px;
        background-color: #005dae;
        text-transform: capitalize;
    }
    .step-title{
        position: absolute;
    }
    .call-report-div{
        margin-left: 20px;
        border: 1px solid #0D75E8;
        border-radius: 8px;
        padding: 2px 12px;
        box-shadow: 1px 1px 2px darkgrey;
    }
    .pearls {
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        margin: 0 0 22px;
        justify-content: center;
    }
    .pearl {
        position: relative;
        padding: 0;
        margin: 0;
        text-align: center;
    }
    .pearle {
        position: relative;
        padding: 0;
        margin: 0;
        text-align: center;
    }
    .pearles {
        position: relative;
        padding: 0;
        margin: 0;
        text-align: center;
    }
    .col-2 {
        -ms-flex: 0 0 16.666666666%;
        flex: 0 0 16.666666666%;
        max-width: 100%;
        width: 100%;
        min-height: 2px;
    }
    .five-stage {
        -ms-flex: 0 0 20%;
        flex: 0 0 20%;
        max-width: 100%;
        width: 100%;
        min-height: 2px;
    }
    .col-3 {
        -ms-flex: 0 0 25%;
        flex: 0 0 25%;
        max-width: 100%;
        width: 100%;
        min-height: 2px;
    }
    .col-4 {
        -ms-flex: 0 0 33.3333333333%;
        flex: 0 0 33.3333333333%;
        max-width: 100%;
        width: 100%;
        min-height: 2px;
    }
    .col-6 {
        -ms-flex: 0 0 50%;
        flex: 0 0 50%;
        max-width: 100%;
        width: 100%;
        min-height: 2px;
    }
    .col-12{
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
        width: 100%;
        min-height: 2px;
    }
    .pearl:before, .pending:before, .active:before, .hold:before, .complete:before, .skip:before {
        left: 0;
    }
    .pearl:after, .pearl:before {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #eee;
    }
    .pearle:after{
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #eee;
    }
    .pearles:before {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        margin-left: -36%;
        background-color: #eee;
    }
    .pearl-icon {
        font-size: 18px;
    }
    .pearl-icon, .pearl-number {
        position: relative;
        z-index: 1;
        display: inline-block;
        width: 30px;
        height: 30px;
        line-height: 32px;
        color: #fff;
        text-align: center;
        background: #bdbdbd;
        border-radius: 50%;
        border: 5px solid #fff;
        outline: 5px solid #bdbdbd;
    }
    .icon {
        display: inline-block;
        font-style: normal;
        font-weight: 400;
        text-rendering: auto;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        -webkit-transform: translate(0,0);
        transform: translate(0,0);
        line-height: 1;
    }
    .pearl-title {
        margin-top: 0.5em;
        display: block;
        font-size: 14px;
        color: #616161;
        margin-bottom: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .btn-new-blue {
        border: 2px solid #005dae;
        color:#fff;
        line-height: 30px;
        border-radius: 5px;
        background-color: #005dae;
        text-transform: capitalize;
    }
    .pending {
        position: relative;
        padding: 0;
        margin: 0;
        text-align: center !important;
    }
    .active {
        position: relative;
        padding: 0;
        margin: 0;
        text-align: center !important;
    }
    .hold {
        position: relative;
        padding: 0;
        margin: 0;
        text-align: center !important;
    }
    .complete {
        position: relative;
        padding: 0;
        margin: 0;
        text-align: center !important;
    }
    .skip {
        position: relative;
        padding: 0;
        margin: 0;
        text-align: center !important;
    }
    .pending .pearl-icon{
        color: #c4c4c4;
        background-color: #c4c4c4;
        border-color: #fff;
        outline: 5px solid #c4c4c4;
    }
    .active .pearl-icon{
        color: #FFBF02;
        background-color: #FFBF02;
        border-color: #fff;
        outline: 5px solid #FFBF02;
    }
    .hold .pearl-icon{
        color: #E25251;
        background-color: #E25251;
        border-color: #fff;
        outline: 5px solid #E25251;
    }
    .complete .pearl-icon{
        color: #1D8A5F;
        background-color: #1D8A5F;
        border-color: #fff;
        outline: 5px solid #1D8A5F;
    }
    .skip .pearl-icon{
        color: #676767;
        background-color: #676767;
        border-color: #fff;
        outline: 5px solid #676767;
    }

    .pending:before {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #c4c4c4;
    }
    .pending:after {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #c4c4c4;
    }
    .active:before {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #FFBF02;
    }
    .active:after {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #FFBF02;
    }
    .hold:before {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #E25251;
    }
    .hold:after {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #E25251;
    }

    .complete:before {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #1D8A5F;
    }
    .complete:after{
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #1D8A5F;
    }
    .skip:before {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #676767;
    }
    .skip:after {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #676767;
    }
    .pending-b:before {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #c4c4c4;
        display: none;
    }
    .pending-a:after {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #c4c4c4;
        display: none;
    }
    .active-b:before {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #FFBF02;
        display: none;
    }
    .active-a:after {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #FFBF02;
        display: none;
    }
    .hold-b:before {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #E25251;
        display: none;
    }
    .hold-a:after {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #E25251;
        display: none;
    }

    .complete-b:before {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #1D8A5F;
        display: none;
    }
    .complete-a:after{
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #1D8A5F;
        display: none;
    }
    .skip-b:before {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #676767;
        display: none;
    }
    .skip-a:after {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #676767;
        display: none;
    }
    .pending-title {
        margin-top: 0.5em;
        display: block;
        font-size: 14px;
        color: #c4c4c4;
        margin-bottom: 0;
        line-break: anywhere;
    }
    .active-title {
        margin-top: 0.5em;
        display: block;
        font-size: 14px;
        color: #FFBF02;
        margin-bottom: 0;
        line-break: anywhere;
    }
    .hold-title {
        margin-top: 0.5em;
        display: block;
        font-size: 14px;
        color: #E25251;
        margin-bottom: 0;
        line-break: anywhere;
    }
    .complete-title {
        margin-top: 0.5em;
        display: block;
        font-size: 14px;
        color: #1D8A5F;
        margin-bottom: 0;
        line-break: anywhere;
    }
    .skip-title {
        margin-top: 0.5em;
        display: block;
        font-size: 14px;
        color: #676767;
        margin-bottom: 0;
        line-break: anywhere;
    }
   @media only screen and (min-width: 768px) and (max-width: 1024px) {
    .col-2 {
        -ms-flex: 0 0 16.666666666%;
        flex: 0 0 16.666666666%;
        max-width: 100%;
        width: 70px;
        min-height: 2px;
    }
    .five-stage {
        -ms-flex: 0 0 20%;
        flex: 0 0 20%;
        max-width: 100%;
        width: 85px;
        min-height: 2px;
    }
    .col-3 {
        -ms-flex: 0 0 25%;
        flex: 0 0 25%;
        max-width: 100%;
        width: 100px;
        min-height: 2px;
    }
    .col-4 {
        -ms-flex: 0 0 33.3333333333%;
        flex: 0 0 33.3333333333%;
        max-width: 100%;
        width: 140px;
        min-height: 2px;
    }
    .col-6 {
        -ms-flex: 0 0 50%;
        flex: 0 0 50%;
        max-width: 100%;
        width: 200px;
        min-height: 2px;
    }
    .col-12{
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
        width: 100%;
        min-height: 2px;
    }
}
@media only screen and (min-width: 1025px) and (max-width: 1280px) {
    .col-2 {
        -ms-flex: 0 0 16.666666666%;
        flex: 0 0 16.666666666%;
        max-width: 100%;
        width: 95px;
        min-height: 2px;
    }
    .five-stage {
        -ms-flex: 0 0 20%;
        flex: 0 0 20%;
        max-width: 100%;
        width: 110px;
        min-height: 2px;
    }
    .col-3 {
        -ms-flex: 0 0 25%;
        flex: 0 0 25%;
        max-width: 100%;
        width: 140px;
        min-height: 2px;
    }
    .col-4 {
        -ms-flex: 0 0 33.3333333333%;
        flex: 0 0 33.3333333333%;
        max-width: 100%;
        width: 190px;
        min-height: 2px;
    }
    .col-6 {
        -ms-flex: 0 0 50%;
        flex: 0 0 50%;
        max-width: 100%;
        width: 280px;
        min-height: 2px;
    }
    .col-12{
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
        width: 100%;
        min-height: 2px;
    }
}
@media only screen and (min-width: 1281px) and (max-width: 1440px) {
    .col-2 {
        -ms-flex: 0 0 16.666666666%;
        flex: 0 0 16.666666666%;
        max-width: 100%;
        width: 115px;
        min-height: 2px;
    }
    .five-stage {
        -ms-flex: 0 0 20%;
        flex: 0 0 20%;
        max-width: 100%;
        width: 130px;
        min-height: 2px;
    }
    .col-3 {
        -ms-flex: 0 0 25%;
        flex: 0 0 25%;
        max-width: 100%;
        width: 175px;
        min-height: 2px;
    }
    .col-4 {
        -ms-flex: 0 0 33.3333333333%;
        flex: 0 0 33.3333333333%;
        max-width: 100%;
        width: 230px;
        min-height: 2px;
    }
    .col-6 {
        -ms-flex: 0 0 50%;
        flex: 0 0 50%;
        max-width: 100%;
        width: 340px;
        min-height: 2px;
    }
    .col-12{
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
        width: 100%;
        min-height: 2px;
    }
}
@media only screen and (min-width: 1441px) and (max-width: 1699px) {
    .col-2 {
        -ms-flex: 0 0 16.666666666%;
        flex: 0 0 16.666666666%;
        max-width: 100%;
        width: 130px;
        min-height: 2px;
    }
    .five-stage {
        -ms-flex: 0 0 20%;
        flex: 0 0 20%;
        max-width: 100%;
        width: 145px;
        min-height: 2px;
    }
    .col-3 {
        -ms-flex: 0 0 25%;
        flex: 0 0 25%;
        max-width: 100%;
        width: 195px;
        min-height: 2px;
    }
    .col-4 {
        -ms-flex: 0 0 33.3333333333%;
        flex: 0 0 33.3333333333%;
        max-width: 100%;
        width: 260px;
        min-height: 2px;
    }
    .col-6 {
        -ms-flex: 0 0 50%;
        flex: 0 0 50%;
        max-width: 100%;
        width: 390px;
        min-height: 2px;
    }
    .col-12{
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
        width: 100%;
        min-height: 2px;
    }
}
@media only screen and (min-width: 1700px) and (max-width: 1920px) {
    .col-2 {
        -ms-flex: 0 0 16.666666666%;
        flex: 0 0 16.666666666%;
        max-width: 100%;
        width: 155px;
        min-height: 2px;
    }
    .five-stage {
        -ms-flex: 0 0 20%;
        flex: 0 0 20%;
        max-width: 100%;
        width: 170px;
        min-height: 2px;
    }
    .col-3 {
        -ms-flex: 0 0 25%;
        flex: 0 0 25%;
        max-width: 100%;
        width: 233px;
        min-height: 2px;
    }
    .col-4 {
        -ms-flex: 0 0 33.3333333333%;
        flex: 0 0 33.3333333333%;
        max-width: 100%;
        width: 310px;
        min-height: 2px;
    }
    .col-6 {
        -ms-flex: 0 0 50%;
        flex: 0 0 50%;
        max-width: 100%;
        width: 465px;
        min-height: 2px;
    }
    .col-12{
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
        width: 100%;
        min-height: 2px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Leads/LeadProfileModal.vue